import { render } from "./functions-and-directives.md?vue&type=template&id=c7e970cc"
const script = {}
script.render = render

export default script